(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"), require("webuploader"));
	else if(typeof define === 'function' && define.amd)
		define(["_", "webuploader"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("_"), require("webuploader")) : factory(root["_"], root["WebUploader"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_340__, __WEBPACK_EXTERNAL_MODULE_342__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition